import Hero from "../sections/Hero";
import ProductsSection from "../sections/ProductsSection";
import UsesBenefits from "../sections/UsesBenefits";
import HowToUse from "../sections/HowToUse";
import CompareTable from "../sections/CompareTable";
import ContactSection from "../sections/ContactSection";

export default function Home() {
  return (
    <>
      <Hero />
      <ProductsSection />
      <UsesBenefits />
      <HowToUse />
      <CompareTable />
      <ContactSection />
    </>
  );
}
